import { Link } from "react-router-dom";
import termsHeroBg from "../assets/termshero.png";

function TermsConditions() {
  return (
    <div className="bg-white">
      <section
        className="relative isolate flex min-h-[180px] items-center justify-center overflow-hidden bg-cover bg-center bg-no-repeat sm:min-h-[200px] md:min-h-[220px]"
        style={{ backgroundImage: `url(${termsHeroBg})` }}
        aria-labelledby="terms-hero-heading"
      >
        <div
          className="absolute inset-0 bg-gradient-to-r from-ink/70 via-ink/50 to-ink/35"
          aria-hidden
        />
        <div className="relative z-10 mx-auto max-w-7xl px-4 py-6 text-center sm:px-8 sm:py-8 md:px-10 lg:px-8">
          <h1
            id="terms-hero-heading"
            className="text-3xl font-semibold tracking-tight text-white sm:text-4xl md:text-5xl"
          >
            Terms and Conditions
          </h1>
        </div>
      </section>

      <section
        className="relative overflow-hidden bg-white py-12 sm:py-16 lg:py-20"
        aria-labelledby="terms-content-heading"
      >
        <div
          className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-brand-light/25 to-transparent"
          aria-hidden
        />

        <div className="relative mx-auto max-w-7xl px-4 sm:px-8 md:px-10 lg:px-8">
          <article className="rounded-2xl border border-brand/10 bg-white p-6 shadow-[0_16px_40px_-24px_rgba(30,22,51,0.22)] ring-1 ring-brand/5 sm:p-8 lg:p-10">
            <p className="text-sm text-ink/60">Last updated: May 02, 2026</p>

            <p className="mt-8 text-base leading-relaxed text-ink/80">
              Please read these terms and conditions carefully before using Our Service.
            </p>

            <h2
              id="terms-content-heading"
              className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl"
            >
              Interpretation and Definitions
            </h2>

            <h3 className="mt-8 text-lg font-semibold text-ink">Interpretation</h3>
            <p className="mt-3 text-base leading-relaxed text-ink/80">
              The words of which the initial letter is capitalized have meanings defined under the
              following conditions. The following definitions shall have the same meaning regardless
              of whether they appear in singular or in plural.
            </p>

            <h3 className="mt-8 text-lg font-semibold text-ink">Definitions</h3>
            <p className="mt-3 text-base leading-relaxed text-ink/80">
              For the purposes of these Terms and Conditions:
            </p>
            <dl className="mt-4 space-y-4 text-base leading-relaxed text-ink/80">
              <div>
                <dt className="font-semibold text-ink">Country</dt>
                <dd className="mt-1">refers to: India</dd>
              </div>
              <div>
                <dt className="font-semibold text-ink">Company</dt>
                <dd className="mt-1">
                  (referred to as either &quot;the Company&quot;, &quot;We&quot;, &quot;Us&quot; or
                  &quot;Our&quot; in this Agreement) refers to Altus Online School.
                </dd>
              </div>
              <div>
                <dt className="font-semibold text-ink">Device</dt>
                <dd className="mt-1">
                  means any device that can access the Service such as a computer, a cellphone or a
                  digital tablet.
                </dd>
              </div>
              <div>
                <dt className="font-semibold text-ink">Service</dt>
                <dd className="mt-1">refers to the Website.</dd>
              </div>
              <div>
                <dt className="font-semibold text-ink">Terms and Conditions</dt>
                <dd className="mt-1">
                  mean these Terms and Conditions that form the entire agreement between You and the
                  Company regarding the use of the Service.
                </dd>
              </div>
              <div>
                <dt className="font-semibold text-ink">Third-party Social Media Service</dt>
                <dd className="mt-1">
                  means any services or content (including data, information, products or services)
                  provided by a third-party that may be displayed, included or made available by the
                  Service.
                </dd>
              </div>
              <div>
                <dt className="font-semibold text-ink">Website</dt>
                <dd className="mt-1">
                  refers to the Altus Online School website at{" "}
                  <a
                    href="https://www.altusschool.com"
                    className="font-medium text-brand underline decoration-brand/30 underline-offset-2 transition hover:text-brand-dark"
                  >
                    www.altusschool.com
                  </a>
                  .
                </dd>
              </div>
              <div>
                <dt className="font-semibold text-ink">You</dt>
                <dd className="mt-1">
                  mean the individual accessing or using the Service, or the company, or other legal
                  entity on behalf of which such individual is accessing or using the Service, as
                  applicable.
                </dd>
              </div>
            </dl>

            <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
              Acknowledgment
            </h2>
            <div className="mt-6 space-y-4 text-base leading-relaxed text-ink/80">
              <p>
                These are the Terms and Conditions governing the use of this Service and the agreement
                that operates between You and the Company. These Terms and Conditions set out the
                rights and obligations of all users regarding the use of the Service.
              </p>
              <p>
                Your access to and use of the Service is conditioned on Your acceptance of and
                compliance with these Terms and Conditions. These Terms and Conditions apply to all
                visitors, users and others who access or use the Service.
              </p>
              <p>
                By accessing or using the Service You agree to be bound by these Terms and Conditions.
                If You disagree with any part of these Terms and Conditions then You may not access
                the Service.
              </p>
              <p>
                You represent that you are over the age of 18. The Company does not permit those under
                18 to use the Service.
              </p>
              <p>
                Your access to and use of the Service is also conditioned on Your acceptance of and
                compliance with the Company&apos;s{" "}
                <Link
                  to="/privacy-policy"
                  className="font-medium text-brand underline decoration-brand/30 underline-offset-2 transition hover:text-brand-dark"
                >
                  Privacy Policy
                </Link>
                . It describes Our policies and procedures on the collection, use and disclosure of Your
                personal information when You use the Application or the Website and tells You about
                Your privacy rights and how the law protects You. Please read it carefully before using
                Our Service.
              </p>
            </div>

            <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
              Links to Other Websites
            </h2>
            <div className="mt-6 space-y-4 text-base leading-relaxed text-ink/80">
              <p>
                Our Service may contain links to third-party web sites or services that are not owned
                or controlled by the Company.
              </p>
              <p>
                The Company has no control over, and assumes no responsibility for, the content,
                privacy policies, or practices of any third party web sites or services. You further
                acknowledge and agree that the Company shall not be responsible or liable, directly or
                indirectly, for any damage or loss caused or alleged to be caused by or in connection
                with the use of or reliance on any such content, goods or services available on or
                through any such web sites or services.
              </p>
              <p>
                We strongly advise You to read the terms and conditions and privacy policies of any
                third-party web sites or services that You visit.
              </p>
            </div>

            <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
              Termination
            </h2>
            <div className="mt-6 space-y-4 text-base leading-relaxed text-ink/80">
              <p>
                We may terminate or suspend Your access immediately, without prior notice or
                liability, for any reason whatsoever, including without limitation if You breach these
                Terms and Conditions.
              </p>
              <p>Upon termination, Your right to use the Service will cease immediately.</p>
            </div>

            <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
              Limitation of Liability
            </h2>
            <div className="mt-6 space-y-4 text-base leading-relaxed text-ink/80">
              <p>
                Notwithstanding any damages that You might incur, the entire liability of the Company
                and any of its suppliers under any provision of these Terms and Your exclusive remedy
                for all of the foregoing shall be limited to the greatest extent permitted by
                applicable law.
              </p>
              <p>
                To the maximum extent permitted by applicable law, in no event shall the Company or
                its suppliers be liable for any special, incidental, indirect, or consequential damages
                whatsoever (including, but not limited to, damages for loss of profits, loss of data or
                other information, for business interruption, for personal injury, loss of privacy
                arising out of or in any way related to the use of or inability to use the Service,
                third-party software and/or third-party hardware used with the Service, or otherwise in
                connection with any provision of these Terms), even if the Company or any supplier has
                been advised of the possibility of such damages and even if the remedy fails of its
                essential purpose.
              </p>
              <p>
                Some states do not allow the exclusion of implied warranties or limitation of liability
                for incidental or consequential damages, which means that some of the above limitations
                may not apply. In these states, each party&apos;s liability will be limited to the
                greatest extent permitted by law.
              </p>
            </div>

            <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
              &quot;AS IS&quot; and &quot;AS AVAILABLE&quot; Disclaimer
            </h2>
            <div className="mt-6 space-y-4 text-base leading-relaxed text-ink/80">
              <p>
                The Service is provided to You &quot;AS IS&quot; and &quot;AS AVAILABLE&quot; and with
                all faults and defects without warranty of any kind. To the maximum extent permitted
                under applicable law, the Company, on its own behalf and on behalf of its Affiliates
                and its and their respective licensors and service providers, expressly disclaims all
                warranties, whether express, implied, statutory or otherwise, with respect to the
                Service, including all implied warranties of merchantability, fitness for a particular
                purpose, title and non-infringement, and warranties that may arise out of course of
                dealing, course of performance, usage or trade practice. Without limitation to the
                foregoing, the Company provides no warranty or undertaking, and makes no representation
                of any kind that the Service will meet Your requirements, achieve any intended results,
                be compatible or work with any other software, applications, systems or services,
                operate without interruption, meet any performance or reliability standards or be error
                free or that any errors or defects can or will be corrected.
              </p>
              <p>
                Without limiting the foregoing, neither the Company nor any of the company&apos;s
                providers makes any representation or warranty of any kind, express or implied: (i) as to
                the operation or availability of the Service, or the information, content, and materials
                or products included thereon; (ii) that the Service will be uninterrupted or
                error-free; (iii) as to the accuracy, reliability, or currency of any information or
                content provided through the Service; or (iv) that the Service, its servers, the
                content, or e-mails sent from or on behalf of the Company are free of viruses, scripts,
                trojan horses, worms, malware, timebombs or other harmful components.
              </p>
              <p>
                Some jurisdictions do not allow the exclusion of certain types of warranties or
                limitations on applicable statutory rights of a consumer, so some or all of the above
                exclusions and limitations may not apply to You. But in such a case the exclusions and
                limitations set forth in this section shall be applied to the greatest extent
                enforceable under applicable law.
              </p>
            </div>

            <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
              Governing Law
            </h2>
            <p className="mt-6 text-base leading-relaxed text-ink/80">
              The laws of India shall govern these Terms and Your use of the Service.
            </p>

            <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
              Disputes Resolution
            </h2>
            <p className="mt-6 text-base leading-relaxed text-ink/80">
              If You have any concern or dispute about the Service, You agree to first try to resolve
              the dispute informally by contacting the Company.
            </p>

            <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
              Severability and Waiver
            </h2>

            <h3 className="mt-8 text-lg font-semibold text-ink">Severability</h3>
            <p className="mt-3 text-base leading-relaxed text-ink/80">
              If any provision of these Terms is held to be unenforceable or invalid, such provision
              will be changed and interpreted to accomplish the objectives of such provision to the
              greatest extent possible under applicable law and the remaining provisions will continue
              in full force and effect.
            </p>

            <h3 className="mt-8 text-lg font-semibold text-ink">Waiver</h3>
            <p className="mt-3 text-base leading-relaxed text-ink/80">
              Except as provided herein, the failure to exercise a right or to require performance of
              an obligation under these Terms shall not affect a party&apos;s ability to exercise such
              right or require such performance at any time thereafter nor shall the waiver of a breach
              constitute a waiver of any subsequent breach.
            </p>

            <h3 className="mt-8 text-lg font-semibold text-ink">Translation Interpretation</h3>
            <p className="mt-3 text-base leading-relaxed text-ink/80">
              These Terms and Conditions may have been translated if We have made them available to
              You on our Service. You agree that the original English text shall prevail in the case of
              a dispute.
            </p>

            <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
              Changes to These Terms and Conditions
            </h2>
            <div className="mt-6 space-y-4 text-base leading-relaxed text-ink/80">
              <p>
                We reserve the right, at Our sole discretion, to modify or replace these Terms at any
                time. What constitutes a material change will be determined at Our sole discretion.
              </p>
              <p>
                By continuing to access or use Our Service after those revisions become effective, You
                agree to be bound by the revised terms. If You do not agree to the new terms, in whole
                or in part, please stop using the website and the Service.
              </p>
            </div>

            <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">Contact Us</h2>
            <p className="mt-6 text-base leading-relaxed text-ink/80">
              If you have any questions about these Terms and Conditions, You can contact us:
            </p>
            <p className="mt-4 text-base leading-relaxed text-ink/80">
              <span className="font-semibold text-ink">By email:</span>{" "}
              <a
                href="mailto:info@altusonlineschool.com"
                className="font-medium text-brand underline decoration-brand/30 underline-offset-2 transition hover:text-brand-dark"
              >
                info@altusonlineschool.com
              </a>
            </p>
          </article>
        </div>
      </section>
    </div>
  );
}

export default TermsConditions;
